import { createAction, props } from '@ngrx/store';
import {
  TeamMember,
  TeamMemberLevel,
  TeamMemberType,
} from '../models/team-member';
import { Role } from '@team-management/models/roles';
import { WcgMenuOption } from '@wcg/frontend-framework';

export const storeRoles = createAction(
  '[Team Management] Store Roles',
  props<{
    level: TeamMemberLevel;
    roles: Role[];
  }>(),
);

export const storeRolesError = createAction(
  '[Team Management] Store Roles Error',
  props<{
    level: TeamMemberLevel;
    error: string;
  }>(),
);

export const loadingRoles = createAction(
  '[Team Management] Loading Roles',
  props<{ level: TeamMemberLevel }>(),
);

export const storeTeam = createAction(
  '[Team Management] Store Team',
  props<{
    entityId: string;
    team: TeamMember[];
    memberType: TeamMemberType;
    page: number;
    pageSize: number;
    total: number;
    level: TeamMemberLevel;
    roles?: WcgMenuOption[];
    status?: WcgMenuOption[];
    visible?: WcgMenuOption[];
  }>(),
);

export const loadingTeam = createAction(
  '[Team Management] Loading Team',
  props<{
    entityId: string;
    level: TeamMemberLevel;
    memberType: TeamMemberType;
  }>(),
);

export const storeTeamError = createAction(
  '[Team Management] Store Team Error',
  props<{
    entityId: string;
    memberType: TeamMemberType;
    level: TeamMemberLevel;
    error: string;
  }>(),
);

export const storeDeleteTeamMemberError = createAction(
  '[Team Management] Store Delete Team Member Error',
  props<{
    memberId: string;
    error: string;
  }>(),
);

export const storeSavingTeamMember = createAction(
  '[Team Management] Store Saving Team Member',
);

export const storeSavingTeamMemberError = createAction(
  '[Team Management] Store Saving Team Member Error',
  props<{
    error: string;
  }>(),
);

export const clearDeleteTeamMemberError = createAction(
  '[Team Management] Clear Delete Team Member Error',
  props<{ memberId: string }>(),
);

export const savedTeamMember = createAction(
  '[Team Management] Saved Team Member',
);
